import { Network } from "../Network";
import { ContactServices } from "./ContactService";
import { PermissionServices } from "./PermissionsService";

export class CompanyDirectoryService {
  static read(data) {
    return PermissionServices.readCompanyContactsTemplate(data);
  }

  static create({ company_id, code, loginEmail, contactDetails }) {
    return Network.fetch(
      `/rest/v1/addContactsInfoCompanyLevel/${company_id}`,
      {
        method: "POST",
        headers: { Authorization: code, From: loginEmail },
        body: JSON.stringify({ code, loginEmail, ...contactDetails }),
      },
    );
  }

  static sync({ company_id, code, loginEmail }) {
    return Network.fetch(`/rest/v1/resyncCompanyContactsInfo/${company_id}`, {
      method: "GET",
      headers: { Authorization: code, From: loginEmail },
    });
  }

  static edit(data) {
    return ContactServices.EditContact({ ...data, id: data.company_id });
  }

  static remove({ company_id, code, loginEmail, inviteeEmail }) {
    return PermissionServices.removeCompanyContactsTemplate({
      company_id,
      loginEmail,
      code,
      inviteeEmail,
    });
  }

  static invite(data) {
    return ContactServices.resendInvitation({
      ...data,
      project_id: data.company_id,
    });
  }

  static async readPermissionTemplates(data) {
    // Use the same company-level template sources as User Permissions.
    const [company, project] = await Promise.all([
      PermissionServices.getCompanyPermissionsTemplate(data),
      PermissionServices.getProjectPermissionsTemplate(data),
    ]);
    const names = (response) => (response.content || [])
      .map((template) => template["Template Name"])
      .filter((name) => name && name !== "Account Owner");
    return {
      companyAssignablePermissions: names(company),
      projectAssignablePermissions: names(project),
    };
  }
}
